import React from 'react';
import { profile } from '../data/profile';
export function Footer() {
  return <footer className="bg-ink-900 py-10" data-id="element-27" data-mp="3gezcj1s77n03">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-6 lg:flex-row lg:items-center lg:justify-between lg:px-10" data-id="element-28" data-mp="3gg0za3iktxxn">
        <p className="text-xl text-white" data-id="element-29" data-mp="32lrm3dfusxjz">{profile.name}</p>
        <p className="text-base text-slate-500" data-id="element-30" data-mp="36qhg0wqyc229">
          Copyright {new Date().getFullYear()} {profile.name}. All rights reserved.
        </p>
      </div>
    </footer>;
}